import { v4 as uuidv4 } from 'uuid';
import apiConst from './constants/Api';

export default async (surveyResponses: any) => {
  const uuid = typeof surveyResponses.id === 'string' ? surveyResponses.id : uuidv4();
  const reqUrl = `${apiConst.backendUrl}/record/${uuid}?type=surveyResponses`;
  const stringifiedResponse = JSON.stringify(surveyResponses);
  fetch(reqUrl, {
    method: 'PUT',
    body: JSON.stringify({ value: stringifiedResponse }),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((resp) => {
    if (resp.status === 200) {
      resp.json().then((respJson) => {
        console.log(respJson);
      });
    } else {
      console.error(resp.statusText);
    }
  });
  console.log(`Uploaded responses to key: ${uuid}`);
};
